import {
    SET_JSON,
    SET_SEARCH_MESSAGE,
    SET_READY_STATUS
} from '../../actions';

const initialState = {
    json: null,
    message: null,
    status: false
}

function searchResultsReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_JSON:
            newState.json = action.json;
            newState.message = state.message;
            newState.status = state.status;
            return newState;
        
        case SET_SEARCH_MESSAGE:
            newState.json = state.json;
            newState.message = action.message;
            newState.status = state.status
            return newState;

        case SET_READY_STATUS:
            newState.json = state.json;
            newState.message = state.message;
            newState.status = action.status;
            return newState;
        
        default:
            return state;

    }
}

export default searchResultsReducer;
